// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"541":"da458701","627":"425a1fef"}[chunkId] || chunkId) + "." + {"541":"f47b4230a95c8803","627":"4dfa3e94480f8b35","1384":"24c80577c613dd53","2182":"6d0c82b1fc4bc12f","3304":"e2d0d3788b6351b5"}[chunkId] + ".js";
};